import React, { Component } from 'react';
import { Link } from "react-router-dom";
import axios from "../../utils/axiosInstance";
import { withNavigation } from "../../utils/withNavigation";
import './AdminLoginPage.css';

class AdminLoginPage extends Component {
  state = {
    website_name: "",
    preview_logo: null,
    powered_by: "",
    username: "",
    password: "",
    error: "",
    loading: false,
  };

  API_BASE = axios.defaults.baseURL || "";
  PUBLIC_BASE = this.API_BASE.replace("/api", "");

  componentDidMount() {
    this.fetchFooterData();
  }

  fetchFooterData = async () => {
    try {
      const res = await axios.get("/theme_customizable");
      const d = res?.data?.data;
      if (d) {
        this.setState({
          website_name: d.website_name || "Bookly",
          powered_by: d.powered_by || "Travel & Tourism Booking Platform",
          preview_logo: d.website_logo ? `${this.PUBLIC_BASE}/${d.website_logo}` : null,
        });
      }
    } catch (error) {
      console.error("Theme fetch error:", error);
    }
  };

  handleChange = (e) => this.setState({ [e.target.name]: e.target.value });

  handleLogin = async (e) => {
    e.preventDefault();
    this.setState({ loading: true, error: "" });

    const { username, password } = this.state;
    const loginUrl = username.startsWith("admin_") ? "/admin/login" : "/merchant/login";

    try {
      const res = await axios.post(loginUrl, { username, password });

      if (res.data.token) {
        const user = res.data.user;
        localStorage.setItem("token", res.data.token);
        localStorage.setItem("auth_token", res.data.token);
        localStorage.setItem("user_id", user?.user_id || "");
        localStorage.setItem("fullname", user?.fullname || "");
        localStorage.setItem("dashboard", user?.dashboard || "");
        localStorage.setItem("bookings", user?.bookings || "");
        localStorage.setItem("posts", user?.posts || "");
        localStorage.setItem("customers", user?.customers || "");
        localStorage.setItem("coupons", user?.coupons || "");
        localStorage.setItem("admins", user?.admins || "");
        localStorage.setItem("seo_pages", user?.seo_pages || "");
        localStorage.setItem("additional_page", user?.additional_page || "");
        localStorage.setItem("landing_page", user?.landing_page || "");
        localStorage.setItem("theme_customization", user?.theme_customization || "");
        localStorage.setItem("settings", user?.settings || "");
        localStorage.setItem("user_role", user?.role || "");
        localStorage.setItem("user", JSON.stringify(user));

        window.location.href = "/admin/dashboard";
      } else {
        this.setState({ error: "No token returned from API!" });
      }
    } catch (err) {
      if (err.response) {
        this.setState({
          error: err.response.data.message || err.response.data.error || "Invalid credentials or server error.",
        });
      } else if (err.request) {
        this.setState({ error: "No response from server." });
      } else {
        this.setState({ error: err.message });
      }
    } finally {
      this.setState({ loading: false });
    }
  };

  render() {
    const { website_name, preview_logo, powered_by, username, password, error, loading } = this.state;

    return (
      <div className="bookly-auth-container">
        <div className="bookly-auth-wrapper">
          {/* Brand Showcase Panel (Desktop View) */}
          <div className="bookly-brand-panel">
            <div className="brand-content-box">
              <span className="badge-travel">Bookly Admin Portal</span>
              <h1>Explore & Manage <span>{website_name || "Bookly"}</span></h1>
              <p>{powered_by || "Your centralized dashboard for global travel, tours, and hospitality booking management."}</p>
              
              <div className="travel-highlights">
                <div className="highlight-item">
                  <i className="fa fa-map-marked-alt"></i>
                  <span>Destination Control</span>
                </div>
                <div className="highlight-item">
                  <i className="fa fa-shield-alt"></i>
                  <span>Encrypted Access</span>
                </div>
              </div>
            </div>
          </div>

          {/* White Glassmorphic Login Form Panel */}
          <div className="bookly-form-panel">
            <div className="glass-card">
              <div className="card-header-section">
                {preview_logo ? (
                  <Link to="#" className="brand-logo-link">
                    <img src={preview_logo} alt="Bookly Logo" className="brand-logo-img" />
                  </Link>
                ) : (
                  <div className="brand-fallback-text">
                    <h2>{website_name || "Bookly"}</h2>
                  </div>
                )}
                <h3>Welcome Back</h3>
                <p>Sign in to manage your travel platform</p>
              </div>

              {error && <div className="alert-error animate-shake">{error}</div>}

              <form className="glass-login-form" onSubmit={this.handleLogin}>
                <div className="form-group-custom">
                  <label>Username</label>
                  <div className="input-with-icon">
                    <i className="fa fa-user"></i>
                    <input
                      type="text"
                      name="username"
                      className="glass-input"
                      placeholder="Enter admin or merchant username"
                      value={username}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                </div>

                <div className="form-group-custom">
                  <label>Password</label>
                  <div className="input-with-icon">
                    <i className="fa fa-lock"></i>
                    <input
                      type="password"
                      name="password"
                      className="glass-input"
                      placeholder="Enter secure password"
                      value={password}
                      onChange={this.handleChange}
                      required
                    />
                  </div>
                </div>

                <button
                  type="submit"
                  className="btn-glass-submit"
                  disabled={loading}
                >
                  {loading ? (
                    <span className="spinner-loading">
                      <i className="fa fa-spinner fa-spin"></i> Authenticating...
                    </span>
                  ) : (
                    <span>Sign In to Dashboard <i className="fa fa-arrow-right"></i></span>
                  )}
                </button>
              </form>

              <div className="glass-card-footer">
                <p>&copy; {new Date().getFullYear()} {website_name || "Bookly"}. All Rights Reserved.</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default withNavigation(AdminLoginPage);
